// 生产控制台相关

export default {
    data: {
        WorkSpaceAttrName: "_workSpace_",

        // 1. 裁床工作台的 id
        cuttingWorkSpace: 1,

        // 2.缝纫工作台 id
        sewWorkWorkSpace: 2,

        // 3.外协工作台
        vendorWorkSpace: 3,

        // 4.后道工作台
        endHandleWorkSpace: 4,

        workTableUrl:'/goods/api/work_tables/',

        dateFormat: 'YYYY-MM-DD',
        dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',

        orderListUrl: '/order_platform/api/platform_orders/',

        // 工艺记录单
        craftListUrl: '/order_platform/api/craft_records/',

        // 工艺小组信息
        craftGroupsUrl: '/order_platform/api/produce_groups/',

        // 工艺小组的任务
        craftGroupRecordUrl: '/order_platform/api/group_craft_records/',

        // 小组任务的批上报
        batchGroupUrl: '/order_platform/api/batch_group_crafts/',

        // 工艺流程模块
        craftProcessUrl: '/goods/api/craft_processes/',

        // 商品的工艺模版
        goodbaseCraftProcessUrl: '/goods/api/goodbase_craft_processes/',

        factoriesUrl: '/order_platform/api/produce_factories/',

        // 产品开发需求文档
        proRequirementUrl:'/order_platform/api/p_requirements/'

    },
    craftMethods: {

        setupCraft(craft) {
            // key:orderSize 的ID  ｜ value: orderSize 对象
            const orderSizeMap = new Map()

            // key:SizeRecord 的ID value:SizeRecord
            const baseSizeRecordMap = new Map()

            craft.order.ordersize_set.forEach((orderSize) => {
                orderSizeMap.set(orderSize.id, orderSize)
            })

            // 将 carft.size_records 的 sizeRecord 进行填充
            // 为 size_records 填充 尺码，颜色，下单数量，前一个工艺的上报数量
            const previousCraft = this.previousCraft(craft)
            craft.size_records.forEach((sizeRecord) => {
                sizeRecord['_num'] = sizeRecord.num             // 拷贝一份通知数据
                sizeRecord['_price'] = sizeRecord.price         // 拷贝一份工艺价格


                sizeRecord['shop_id'] = orderSizeMap.get(sizeRecord.size).size.shop_id
                sizeRecord['color'] = orderSizeMap.get(sizeRecord.size).color
                sizeRecord['ordered_amount'] = orderSizeMap.get(sizeRecord.size).ordered_amount
                if (previousCraft) {
                    previousCraft.size_records.forEach((preSizeRecord) => {
                        // 判断前一步工艺的尺码与当前的尺码是否相同
                        if (preSizeRecord.size === sizeRecord.size) {
                            sizeRecord['pre_finish_num'] = preSizeRecord.finish_num
                        }
                    })
                } else {
                    sizeRecord['pre_finish_num'] = 0
                }
                baseSizeRecordMap.set(sizeRecord.id, sizeRecord)
            })

            craft.groupcraftrecord_set.forEach((GroupCraft) => {
                GroupCraft.sizegroupcraftrecord_set.forEach((sizeGroupCraft) => {
                    const fullSizeRecord = baseSizeRecordMap.get(sizeGroupCraft.size_craft_record)

                    sizeGroupCraft['shop_id'] = fullSizeRecord['shop_id']
                    sizeGroupCraft['sumPlan'] = fullSizeRecord['num']

                    const addTempAttrs = ['plan_num', 'price', 'scrap_num']
                    addTempAttrs.forEach(field => {
                        const tempField = '_' + field   // copy 出来的临时变量
                        sizeGroupCraft[tempField] = sizeGroupCraft[field]
                    })
                })
            })

        },

        isCanChange(craft) {
            return new Set(['draft', 'submit']).has(craft.status)
        },
        isDraft(craft) {
            return craft.status === 'draft'
        },
        isSubmit(craft) {
            return craft.status === 'submit'
        },
        // 是否可以反审
        isReverseVerify(craft) {
            return craft.status === 'verify'
        },
        isVerify(craft) {
            return craft.status === 'verify'
        },
        isHeadAndApplyFinish(craft) {
            return !craft.previous && craft.order.applyinfo.current === 'FINISH'
        },
        /**
         * 前一步的工艺记录单
         */
        previousCraft(craft) {
            if (!craft.previous) {
                return null
            } else {
                for (let i = 0; i < craft.order.craftrecord_set.length; i++) {
                    const craftrecord = craft.order.craftrecord_set[i]
                    if (craftrecord.id === craft.previous) {
                        return craftrecord
                    }
                }
            }
        },

        notHeadButPreviousFinish(craft) {
            const pCraft = this.previousCraft(craft);
            return pCraft && pCraft.finish
        },
    },
    install(Vue) {
        Vue.prototype.$const = this.data
        Vue.prototype.$craftMethods = this.craftMethods
    }
}


